import request from "@/utils/request";
import { getAuthorizationHeader } from ".";

export async function create(payment) {
  return (await request.post("/payments", payment, getAuthorizationHeader())).data.data;
}